import { Button } from '@mantine/core';
import { IconFileTypeZip } from '@tabler/icons-react';

import { Id } from '@feature/utils';

interface EvaluationReportZipButtonProps {
  evaluationId: Id;
  authorId: Id;
}

const onDownload = (evaluationId: Id, authorId: Id) => {
  window.open(`/api/author-evaluation/${evaluationId}/author/${authorId}/data/zip`);
};

export function EvaluationReportZipButton({ evaluationId, authorId }: EvaluationReportZipButtonProps) {
  return (
    <Button
      size="xs"
      leftSection={<IconFileTypeZip size="24px" />}
      onClick={() => onDownload(evaluationId, authorId)}
    >
      Descarcă arhivă dovezi
    </Button>
  );
}
